import { computed, ref } from 'vue';

export function useNucleoWorkOrderDetailActions({ route, router, state }) {
  const dialog = ref(null);
  const executionService = ref(null);

  const goBack = () =>
    router.push({
      name: 'operacao_imobiliaria_nucleo',
      params: { accountId: route.params.accountId },
    });
  const openDialog = payload => {
    dialog.value = payload;
  };
  const closeDialog = () => {
    dialog.value = null;
  };
  const openExecution = service => {
    executionService.value = service;
  };
  const closeExecution = () => {
    executionService.value = null;
  };
  const returnToQueueAfterFinalization = () =>
    router.push({
      name: 'operacao_imobiliaria_nucleo',
      params: { accountId: route.params.accountId },
      query: { feedback: 'finalizar-pedido' },
    });
  const saveAction = async payload => {
    if (await state.runAction(payload)) {
      closeDialog();
      if (payload.action === 'accept') returnToQueueAfterFinalization();
    }
  };
  const saveExecution = async payload => {
    if (
      await state.runServiceExecution({
        service: executionService.value,
        ...payload,
      })
    ) {
      closeExecution();
    }
  };
  const acceptPayload = computed(() => ({
    action: 'accept',
    service: { id: state.detail.value?.id },
  }));
  const viewProperty = () => {
    const salesTransactionId =
      state.detail.value?.documentos?.property_transaction_id;
    if (!salesTransactionId) return;

    router.push({
      name: 'operacao_imobiliaria_nucleo_venda_detalhes',
      params: { accountId: route.params.accountId, salesTransactionId },
      query: {
        imovel_listing_id: route.params.imovelListingId,
        work_order_id: route.params.workOrderId,
      },
    });
  };

  return {
    dialog,
    executionService,
    goBack,
    openDialog,
    closeDialog,
    openExecution,
    closeExecution,
    saveAction,
    saveExecution,
    acceptPayload,
    viewProperty,
  };
}
